// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".st-container{margin-top:48px}.st-container>*>:not(.grid-flow-row)[class*=\" bg-\"]:not([class*=\" bg-white\"]),.st-container>*>:not(.grid-flow-row)[class^=bg-]:not([class^=bg-white]){padding-bottom:48px;padding-top:48px}.st-container>*>:first-child{margin-top:0}.st-container>.base-grid{row-gap:48px}.st-container>.grid+.grid:not(.grid-flow-row){margin-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
